module.exports = [{"type":"title","text":"2024-10-09"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位Websocket服務：每次新建連接都會推送全量的“賬戶餘額和倉位更新推送”數據，之後每5秒推送一次。"},{"type":"html","text":"永續U本位Websocket服務：每次新建連接都會推送全量的“槓桿倍數和保證金模式”數據，之後每5秒推送一次。"},{"type":"html","text":"永續U本位Restful服務：‘持倉與維持保證金率’接口新增tier字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-10-09.json
// module id = zB9+
// module chunks = 3